import { useCallback } from 'react';

import { ONBOARDING_STAGE } from 'src/data/onboarding';
import * as events from 'src/lib/events';
import { useTrackingEvent } from 'src/services';
import { useUiActions, useUserActions } from 'src/store';

const STAGE = ONBOARDING_STAGE.webinarBanner3;
const MAX_BANNER_DISPLAY_COUNT = 4;

export const useHandlers = ({ url }) => {
  const uiActions = useUiActions();
  const userActions = useUserActions();
  const trackEvent = useTrackingEvent();

  const handleClose = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();

      const count = Number(userActions.getOnboardingStageValue(STAGE)) || 0;

      uiActions.setShowWebinarBanner(false);
      userActions.updateOnboardingStageValue(STAGE, String(count + 1));

      if (count >= MAX_BANNER_DISPLAY_COUNT) {
        userActions.finishOnboardingStage(STAGE);
      }
    },
    [uiActions, userActions]
  );

  const handleClick = useCallback(
    (event) => {
      event.stopPropagation();

      trackEvent(events.DASHBOARD.clickedWebinarBanner, {
        url,
      });
    },
    [trackEvent, url]
  );

  return { handleClose, handleClick };
};
